import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const TruckFullIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    fill="none"
    height="24"
    optimizationId="tama-truck-full"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      d="M6 20C5.16667 20 4.45833 19.7083 3.875 19.125C3.29167 18.5417 3 17.8333 3 17H1V6C1 5.45 1.196 4.97933 1.588 4.588C1.97933 4.196 2.45 4 3 4H17V8H20L23 12V17H21C21 17.8333 20.7083 18.5417 20.125 19.125C19.5417 19.7083 18.8333 20 18 20C17.1667 20 16.4583 19.7083 15.875 19.125C15.2917 18.5417 15 17.8333 15 17H9C9 17.8333 8.70833 18.5417 8.125 19.125C7.54167 19.7083 6.83333 20 6 20ZM6 18C6.28333 18 6.521 17.904 6.713 17.712C6.90433 17.5207 7 17.2833 7 17C7 16.7167 6.90433 16.4793 6.713 16.288C6.521 16.096 6.28333 16 6 16C5.71667 16 5.479 16.096 5.287 16.288C5.09567 16.4793 5 16.7167 5 17C5 17.2833 5.09567 17.5207 5.287 17.712C5.479 17.904 5.71667 18 6 18ZM18 18C18.2833 18 18.5207 17.904 18.712 17.712C18.904 17.5207 19 17.2833 19 17C19 16.7167 18.904 16.4793 18.712 16.288C18.5207 16.096 18.2833 16 18 16C17.7167 16 17.4793 16.096 17.288 16.288C17.096 16.4793 17 16.7167 17 17C17 17.2833 17.096 17.5207 17.288 17.712C17.4793 17.904 17.7167 18 18 18ZM17 13H21.25L19 10H17V13Z"
      fill="currentColor"
    />
  </Svg>
));

TruckFullIcon.displayName = 'TruckFullIcon';
